import React from "react";
import moment from "moment";
import {
  Box, CircularProgress, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Delete02Icon, PencilEdit01Icon} from "@hugeicons/core-free-icons";
import {SERVICE_FIELDS} from "../serviceFields";

const COLUMNS = ["Name", "Services", "Access", "Date Updated", "Action"];

export const BackendConfigurationsTable = ({configurations, loading, emptyText, getOrgName, canManage, onEdit, onDelete}) => {
  const columns = canManage ? COLUMNS : COLUMNS.filter(column => column !== "Action");

  return (
    <Table>
      <TableHead>
        <TableRow>
          {columns.map(column => (
            <TableCell key={column} sx={{fontWeight: 700}}>{column}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {loading && (
          <TableRow>
            <TableCell colSpan={columns.length} align={"center"} sx={{py: 4}}>
              <CircularProgress size={28}/>
            </TableCell>
          </TableRow>
        )}
        {!loading && configurations.length === 0 && (
          <TableRow>
            <TableCell colSpan={columns.length} align={"center"} sx={{py: 4, color: "text.secondary"}}>
              {emptyText}
            </TableCell>
          </TableRow>
        )}
        {!loading && configurations.map(configuration => (
          <BackendConfigurationRow
            key={configuration.id}
            configuration={configuration}
            orgName={getOrgName(configuration.organizationId)}
            canManage={canManage}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </TableBody>
    </Table>
  );
};

const BackendConfigurationRow = ({configuration, orgName, canManage, onEdit, onDelete}) => {
  const services = SERVICE_FIELDS.filter(field => configuration[field.name]);

  return (
    <TableRow>
      <TableCell sx={{verticalAlign: "top"}}>
        <Typography fontWeight={500}>{configuration.name || "—"}</Typography>
      </TableCell>
      <TableCell>
        {services.length === 0 && "—"}
        {services.map(field => (
          <Box key={field.name} sx={{maxWidth: 420}}>
            <Typography variant={"caption"} color={"text.secondary"} sx={{display: "block"}}>
              {field.label}
            </Typography>
            <Typography variant={"body2"} fontFamily={"monospace"} fontSize={13} noWrap title={configuration[field.name]}>
              {configuration[field.name]}
            </Typography>
          </Box>
        ))}
      </TableCell>
      <TableCell sx={{verticalAlign: "top"}}>
        <Typography variant={"body2"} color={configuration.isPublic ? "text.secondary" : "text.primary"}>
          {orgName}
        </Typography>
      </TableCell>
      <TableCell sx={{verticalAlign: "top", whiteSpace: "nowrap"}}>
        {configuration.dateUpdated ? moment(configuration.dateUpdated).format("DD MMM YYYY HH:mm") : "—"}
      </TableCell>
      {canManage && (
        <TableCell padding={"checkbox"} sx={{verticalAlign: "top"}}>
          <Stack direction={"row"} gap={1} alignItems={"center"} sx={{px: 1, py: 1}}>
            <IconButton sx={{borderRadius: "50% !important"}} onClick={() => onEdit(configuration)}>
              <HugeiconsIcon icon={PencilEdit01Icon} size={18}/>
            </IconButton>
            <IconButton color={"error"} sx={{borderRadius: "50% !important"}} onClick={() => onDelete(configuration)}>
              <HugeiconsIcon icon={Delete02Icon} size={18}/>
            </IconButton>
          </Stack>
        </TableCell>
      )}
    </TableRow>
  );
};
